'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461 from "./presto.types$-Directive-Description$$anon$61.js";
import * as $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462 from "./presto.types$-Directive-Description$$anon$62.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveDescription$() {
  this.c5d = null;
  this.c5e = false;
  this.c5b = null;
  this.c5c = false;
  this.c5h = null;
  this.c5i = false;
  this.c5f = null;
  this.c5g = false;
  this.c5j = null;
  this.c5k = false;
}
export { $c_Lpresto_types$DirectiveDescription$ as $c_Lpresto_types$DirectiveDescription$ };
$p = $c_Lpresto_types$DirectiveDescription$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveDescription$;
/** @constructor */
function $h_Lpresto_types$DirectiveDescription$() {
}
export { $h_Lpresto_types$DirectiveDescription$ as $h_Lpresto_types$DirectiveDescription$ };
$h_Lpresto_types$DirectiveDescription$.prototype = $p;
$p.cHV = (function() {
  if ((!this.c5e)) {
    this.c5d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c5e = true;
  }
  return this.c5d;
});
$p.v2 = (function() {
  if ((!this.c5c)) {
    this.c5b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5c = true;
  }
  return this.c5b;
});
$p.cIF = (function() {
  if ((!this.c5i)) {
    this.c5h = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5i = true;
  }
  return this.c5h;
});
$p.cIs = (function() {
  if ((!this.c5g)) {
    this.c5f = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002461.$c_Lpresto_types$DirectiveDescription$$anon$61(this);
    this.c5g = true;
  }
  return this.c5f;
});
$p.cIW = (function() {
  if ((!this.c5k)) {
    this.c5j = new $j_presto$002etypes$0024$002dDirective$002dDescription$0024$0024anon$002462.$c_Lpresto_types$DirectiveDescription$$anon$62(this);
    this.c5k = true;
  }
  return this.c5j;
});
var $d_Lpresto_types$DirectiveDescription$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveDescription$, "presto.types$DirectiveDescription$", ({
  Zr: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveDescription$ as $d_Lpresto_types$DirectiveDescription$ };
var $n_Lpresto_types$DirectiveDescription$;
function $m_Lpresto_types$DirectiveDescription$() {
  if ((!$n_Lpresto_types$DirectiveDescription$)) {
    $n_Lpresto_types$DirectiveDescription$ = new $c_Lpresto_types$DirectiveDescription$();
  }
  return $n_Lpresto_types$DirectiveDescription$;
}
export { $m_Lpresto_types$DirectiveDescription$ as $m_Lpresto_types$DirectiveDescription$ };
//# sourceMappingURL=presto.types$-Directive-Description$.js.map
